import { Configuration } from './configuration';

export const environment: Configuration = {
  url: 'https://app-cubivuesaasmicroservicesmasterlocationservice-test-001.azurewebsites.net',
  planningPortalUrl:
    'https://app-cubivuesaasmicroservicesplanningportalservice-test-001.azurewebsites.net',
  dawaUrl: 'https://dawa.aws.dk',
  tolgee: {
    // cdnUrl: 'https://sttranslationsprod001.blob.core.windows.net/public/a5c5c4412b47dccbb71fd1f25695bd67',
    apiKey: 'tgpak_g5pwemdtnbrxgyteojuxi3dggjxgiobwnrzxioljgm4de',
    apiURL:
      'https://ca-tms.happymeadow-d5db8391.westeurope.azurecontainerapps.io',
  },
};
